/* eslint-disable no-empty */
import { Component, Prop, Ref, SimpleEvent } from "@eastsideco/salvo-ts";
import { ThemeComponent } from "@/theme/ThemeComponent";
import { elevate, type Algorithm, ProductPage } from '@apptus/esales-api';
import { ProductForm } from "./ProductForm";
import { VoyadoRecommendations } from "../Voyado/VoyadoRecommendations";
import { resetElevateSessionIfTrackingConsentDenied } from "@/utils/elevate";

declare global {
    interface Window {
        elevate: ReturnType<typeof elevate>;
    }
}

/**
 * Product Details
 */
@Component
export class ProductDetails extends ThemeComponent {
    @Prop product!: Shopify.Liquid.Product;

    @Ref productForm!: ProductForm;

    private _onVoyadoProductLoaded = new SimpleEvent<ProductPage>();

    public get onVoyadoProductLoaded() {
        return this._onVoyadoProductLoaded.asEvent();
    }

    private voyadoProductLoaded(productPage: ProductPage) {
        this._onVoyadoProductLoaded.dispatch(productPage);
    }

    init() {
        const interval = setInterval(() => {
            if (!window.elevate) {
                return;
            }

            void this.getVoyadoTicket();

            clearInterval(interval);
        }, 200);
    }

    async getVoyadoTicket() {
        if (!window.elevate) {
            return;
        }

        const recommendationsSections = document.querySelectorAll<VoyadoRecommendations>("voyado-recommendations");

        const algorithms = [
            "STYLE_WITH",
            ...[
                ...recommendationsSections
            ].map((section) => section.algorithm)
        ] as Algorithm[];

        const recommendationLists = algorithms.map((algorithm) => ({
            id: algorithm,
            algorithm
        }));

        resetElevateSessionIfTrackingConsentDenied();

        const response = await window.elevate.query.productPage(
            {
                productKey: this.product.id.toString()
            },
            {
                productGroup: {
                    include: true,
                },
                recommendationLists
            }
        );

        this.voyadoProductLoaded(response);

        this.productForm.voyadoTicket = Object.values(response.tickets)[0];
    }
}
